import {
  ADD_RECENTLY_VIEWED_WORKSPACE,
  GET_RECENTLY_VIEWED_WORKSPACES,
} from 'src/redux/workspaces/actions';
import { createReducer } from 'src/utils/create-reducer';
import { RecentWorkspace } from 'src/utils/recently-viewed-workspaces-store';

export const MAX_RECENTLY_VIEWED_WORKSPACES = 5;

export type RecentlyViewedWorkspaces = RecentWorkspace[];

const initialState: RecentlyViewedWorkspaces = [];

export const recentlyViewedWorkspacesReducer = createReducer(initialState, {
  [ADD_RECENTLY_VIEWED_WORKSPACE](state, action) {
    const workspaceUuid = action.payload.result;
    const { slug } = action.payload.entities.workspaces[workspaceUuid];
    const workspace: RecentWorkspace = { uuid: workspaceUuid, slug };
    const idx = state.findIndex(ws => ws.uuid === workspaceUuid);

    if (idx === 0) {
      return state;
    }

    if (idx !== -1) {
      return [workspace, ...state.slice(0, idx), ...state.slice(idx + 1)];
    }

    return [workspace, ...state.slice(0, MAX_RECENTLY_VIEWED_WORKSPACES - 1)];
  },

  // Load cached workspaces from localstorage
  [GET_RECENTLY_VIEWED_WORKSPACES](state, action) {
    if (!action.payload) {
      return state;
    }
    return [...action.payload];
  },
});
